import i18n from 'services/base/i18n';

export default {
  domainOption:  () => i18n.pgettext('Components|List History|Filter History|Site Entry', 'Add domain name'),
  addressOption: () => i18n.pgettext('Components|List History|Filter History|Site Entry', 'Add IP address'),
  rangeOption:   () => i18n.pgettext('Components|List History|Filter History|Site Entry', 'Add IP range'),
  networkOption: () => i18n.pgettext('Components|List History|Filter History|Site Entry', 'Add IP network'),
};
